import useSWR from 'swr'
import { axiosFetcher, type AxiosFetcherKey } from '../../utils/api/axios-fetcher'
import { Servers } from '../../utils/api/servers'
import { useEffect, useState } from 'react'
import { type KeyedMutator } from 'swr/dist/_internal'

export function useFirmwidePricingConfig (isAuthorized: boolean, accessToken: string | null): {
  firmwidePricingConfig: Record<string, string>
  mutate: KeyedMutator<Record<string, string>>
} {
  const [firmwidePricingConfig, setFirmwidePricingConfig] = useState<Record<string, string>>({})

  const { data, error, mutate } = useSWR<Record<string, string>, boolean, AxiosFetcherKey>(
    isAuthorized ? [Servers.STRATEGY_GATEWAY, null, 'strategy-management/firmwide-pricing-config', accessToken, null] : null,
    axiosFetcher,
    {
      shouldRetryOnError: true,
      refreshInterval: 5000
    }
  )

  useEffect(() => {
    if (data == null || (error === true)) {
      setFirmwidePricingConfig({})
    } else {
      setFirmwidePricingConfig(data)
    }
  }, [data, error])

  return { firmwidePricingConfig, mutate }
}
